import React from 'react';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';

const TeacherSignupForm = props => {
    return (
        <div className="inputPageContainer">
            <div className="inputPage">
                <h1>Teacher Signup</h1>
                <form onSubmit={props.handleSubmit}>
                    <div>
                        <div className="inputRow">
                            <SelectField
                                hintText={"School"}
                                name="school"
                                value={props.school}
                                onChange={props.handleDropdownChangeSchool}
                                iconStyle={{paddingLeft: "22px"}}
                            >
                                {props.schoolOptions}
                            </SelectField>
                        </div>
                        <div className="inputRow">
                            <SelectField
                                hintText={"Class (if already created)"}
                                name="class"
                                value={props.class}
                                onChange={props.handleDropdownChangeClass}
                                iconStyle={{paddingLeft: "22px"}}
                            >
                                {props.classOptions}
                            </SelectField>
                        </div>
                    </div>
                    <TextField
                        hintText="First Name"
                        underlineShow={false}
                        name="firstName"
                        className="inputRow"
                        fullWidth={true}
                        onChange={props.handleChange}
                    />
                    <Divider />
                        <TextField
                            hintText="Last Name"
                            underlineShow={false}
                            name="lastName"
                            className="inputRow"
                            value={props.lastName}
                            fullWidth={true}
                            onChange={props.handleChange}
                        />
                    <Divider />
                        <TextField
                            hintText="Email address"
                            underlineShow={false}
                            className="inputRow"
                            fullWidth={true}
                            name="email"
                            value={props.email}
                            onChange={props.handleChange}
                            type="email"
                        />
                    <Divider />
                        <TextField
                            hintText="Password"
                            underlineShow={false}
                            className="inputRow"
                            fullWidth={true}
                            type="password"
                            name="password"
                            value={props.password}
                            onChange={props.handleChange}
                    />
                    <Divider />
                    <button type="submit" className="pink">Sign Up</button>
                </form>
                <p className="errorMessage">{props.errMsg}</p>
            </div>
        </div>
    );
}

export default TeacherSignupForm;
